import type { GridCustomHeaderCellProps } from "@tql/ui-components-react/kendo/grid";
import { Checkbox } from "@tql/ui-components-react/kendo/inputs";

type SelectCellHeaderProps = GridCustomHeaderCellProps & {
	allDataSelected: boolean;
	setAllDataSelected: (selected: boolean) => void;
	onSelectChange: (selected: boolean) => void;
};

export const SelectCellHeader = ({
	allDataSelected,
	setAllDataSelected,
	onSelectChange,
	...gridProps
}: SelectCellHeaderProps) => {
	const handleChange = (event: {
		value: boolean;
		syntheticEvent: React.SyntheticEvent;
	}) => {
		setAllDataSelected(!allDataSelected);
		onSelectChange(event.value);
	};

	// Transform and filter thProps to fix ARIA attributes and remove invalid DOM attributes
	const originalProps = gridProps.thProps ? { ...gridProps.thProps } : {};
	const transformedThProps: Record<string, unknown> = {};

	// Copy all valid props and transform ARIA attributes
	for (const [key, value] of Object.entries(originalProps)) {
		switch (key) {
			case "ariaSort": {
				transformedThProps["aria-sort"] = value;
				break;
			}
			case "ariaColumnIndex": {
				transformedThProps["aria-colindex"] = value;
				break;
			}
			case "ariaSelected": {
				transformedThProps["aria-selected"] = value;
				break;
			}
			case "ariaDescription": {
				transformedThProps["aria-description"] = value;
				break;
			}
			case "columnId": {
				// Skip this non-DOM attribute
				break;
			}
			default: {
				// Copy all other valid attributes
				transformedThProps[key] = value;
				break;
			}
		}
	}

	return (
		<th {...transformedThProps}>
			<Checkbox checked={allDataSelected} onChange={handleChange} />
		</th>
	);
};
